import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import HrbTranslate from '../../../components/language/HrbTranslate'
import './TicketBasicInformation.scss'

const TicketTab = (props) => {
    const { labelKey, tabKey, selectedTab, showIndicator } = props;

    return (
        <div className={classnames('ticket-tab', {
            'selected-tab': tabKey === selectedTab,
            'indicator': showIndicator
        })} onClick={props.onClick}>
            <h5 className='hnav-tabs medium-weight'>
                <HrbTranslate text={labelKey} />                
            </h5>
            
        </div>
    );
}

TicketTab.whyDidYouRender = false;

TicketTab.propTypes = {
    labelKey: PropTypes.string.isRequired,
    tabKey: PropTypes.string.isRequired,
    selectedTab: PropTypes.string.isRequired,
    showIndicator: PropTypes.bool
}

export default TicketTab